// extracted by mini-css-extract-plugin
export default {"container":"Message_container__+Huz3","page":"Message_page__+sTVs","content":"Message_content__7ZFJP"};